'use strict';

var _regeneratorRuntime = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _objectSpread = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");

var _asyncToGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _defineProperty = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var dagCBOR = require('ipld-dag-cbor');

var dagPB = require('ipld-dag-pb');

var ipldRaw = require('ipld-raw');

var CID = require('cids');

var multihash = require('multihashes');

var configure = require('../lib/configure');

var multipartRequest = require('../lib/multipart-request');

var toUrlSearchParams = require('../lib/to-url-search-params');

var anySignal = require('any-signal');

var AbortController = require('abort-controller').default;

var multicodec = require('multicodec');

module.exports = configure(function (api, opts) {
  var _formats;

  var formats = (_formats = {}, _defineProperty(_formats, multicodec.DAG_PB, dagPB), _defineProperty(_formats, multicodec.DAG_CBOR, dagCBOR), _defineProperty(_formats, multicodec.RAW, ipldRaw), _formats);
  var ipldOptions = opts && opts.ipld || {};
  var configuredFormats = ipldOptions && ipldOptions.formats || [];
  configuredFormats.forEach(function (format) {
    formats[format.codec] = format;
  });
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dagNode) {
        var options,
            cid,
            number,
            format,
            serialized,
            controller,
            signal,
            res,
            data,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

                if (!(options.cid && (options.format || options.hashAlg))) {
                  _context.next = 5;
                  break;
                }

                throw new Error('Failed to put DAG node. Provide either `cid` OR `format` and `hashAlg` options');

              case 5:
                if (!(options.format && !options.hashAlg || !options.format && options.hashAlg)) {
                  _context.next = 7;
                  break;
                }

                throw new Error('Failed to put DAG node. Provide `format` AND `hashAlg` options');

              case 7:
                if (options.cid) {
                  cid = new CID(options.cid);
                  options = _objectSpread({}, options, {
                    format: cid.codec,
                    hashAlg: multihash.decode(cid.multihash).name
                  });
                  delete options.cid;
                }

                options = _objectSpread({
                  format: 'dag-cbor',
                  hashAlg: 'sha2-256',
                  inputEnc: 'raw'
                }, options);
                number = multicodec.getNumber(options.format);
                format = formats[number];

                if (format) {
                  _context.next = 18;
                  break;
                }

                if (!(opts && opts.ipld && opts.ipld.loadFormat)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 15;
                return opts.ipld.loadFormat(options.format);

              case 15:
                format = _context.sent;

              case 16:
                if (format) {
                  _context.next = 18;
                  break;
                }

                throw new Error('Format unsupported - please add support using the options.ipld.formats or options.ipld.loadFormat options');

              case 18:
                if (!(!format.util || !format.util.serialize)) {
                  _context.next = 20;
                  break;
                }

                throw new Error('Format does not support utils.serialize function');

              case 20:
                serialized = format.util.serialize(dagNode); // allow aborting requests on body errors

                controller = new AbortController();
                signal = anySignal([controller.signal, options.signal]);
                _context.t0 = api;
                _context.t1 = _objectSpread;
                _context.t2 = {
                  timeout: options.timeout,
                  signal: signal,
                  searchParams: toUrlSearchParams(options)
                };
                _context.next = 28;
                return multipartRequest(serialized, controller, options.headers);

              case 28:
                _context.t3 = _context.sent;
                _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
                _context.next = 32;
                return _context.t0.post.call(_context.t0, 'dag/put', _context.t4);

              case 32:
                res = _context.sent;
                _context.next = 35;
                return res.json();

              case 35:
                data = _context.sent;
                return _context.abrupt("return", new CID(data.Cid['/']));

              case 37:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
});